import { postAPI } from "../services/api";

export const sendReportToSFMC = async (storeId, workOrderId) => {
    try{
        const route = `/salesforce/send-report/${storeId}/${workOrderId}`;
        const response = await postAPI("", route, "");
        return response;
    }
    catch(e){
        console.log(e)
    }
};